import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

export default function SsoCallback() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }} aria-busy>
        <CircularProgress sx={{ color: 'text.primary' }} />
        <AuthenticateWithRedirectCallback />
      </Box>
    </Box>
  );
}
